import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';
import { getSelectedDay } from '../../../../stores/algos-list/getters';
import useAlgosDataFiltered from '../../../../hooks/useAlgosDataFiltered';
import SortArrows from '../../../../components/SortArrows';
import CountItem from './CountItem';

const useStyles = makeStyles(() => ({
  root: {
    display: 'inline-flex',
    alignItems: 'center',

    '& .count': {
      marginLeft: 5,
    },

    '& .countHolder': {
      marginLeft: 5,
      marginRight: 5,
      display: 'inline-flex',
      alignItems: 'center',
    },
  },
}));

function useData() {
  const selectedDay = useSelector(getSelectedDay);
  const algos = useAlgosDataFiltered(selectedDay);
  const hasError = algos.filter((a) => a.hasError).length;
  const hasWaiting = algos
    .filter((a) => !a.hasError)
    .filter((a) => a.hasWaitingWT).length;
  const stoplossTrailing = algos.filter((a) => a.stoplossTrailing).length;
  const totalErrors = hasError + hasWaiting + stoplossTrailing;

  return {
    hasError,
    hasWaiting,
    stoplossTrailing,
    totalErrors,
  };
}

const AlertCount = () => {
  const classes = useStyles();
  const { hasError, hasWaiting, stoplossTrailing, totalErrors } = useData();

  return (
    <div className={classes.root}>
      {totalErrors ? (
        <div className="countHolder">
          {hasError ? (
            <CountItem count={hasError} className="count" color="danger" />
          ) : null}
          {hasWaiting ? (
            <CountItem count={hasWaiting} className="count" color="primary" />
          ) : null}
          {stoplossTrailing ? (
            <CountItem
              count={stoplossTrailing}
              className="count"
              color="warning"
            />
          ) : null}
        </div>
      ) : null}

      <SortArrows dataKey="alerts" placeholder={totalErrors ? false : true} />
    </div>
  );
};

export default AlertCount;
